import React, {useEffect, useState} from "react";
import ApiService from "../util/ApiService";
import Swal from "sweetalert2";
import Skeleton from "react-loading-skeleton";
import 'react-loading-skeleton/dist/skeleton.css';
import './assets/css/DocumentsTab.css';
import LoadingScreen from '../util/LoadingScreen';
import AuthService from "../login/AuthService";
import DocEditModal from './DocEditModal';

const DocumentsTab = ({documents, onRemoveDocument, reflesh, loadingPage}) => {

    const [ufs, setUfs] = useState([]);
    const [viewingDoc, setViewingDoc] = useState(null);
    const [editingDoc, setEditingDoc] = useState(null);
    const [showEditModal, setShowEditModal] = useState(false);


    const handleDeleteDocument = async (docId) => {
        const result = await Swal.fire({
            title: 'Você tem certeza?',
            text: 'Esta ação não pode ser desfeita!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sim, excluir!',
            cancelButtonText: 'Cancelar'
        });

        if (result.isConfirmed) {
            setLoadingPage(true);
            try {
                const res = await ApiService.send('delete', process.env.REACT_APP_URL_API + `doc/delete`, {id: docId}, true);
                if (res.code === 200) {
                    Swal.fire({ icon: 'success', title: 'Documento excluído com sucesso!' });
                    if (onRemoveDocument) onRemoveDocument(docId);
                } else {
                    Swal.fire({ icon: 'error', title: 'Erro ao excluir documento', text: res.data.message });
                }
            } catch (error) {
                ApiService.handleApiError(error);
            } finally {
                setLoadingPage(false);
            }
        }
    };

    const handleEditDocument = (doc) => {
        setEditingDoc(doc);
        setShowEditModal(true);
    };

    const handleViewDocument = (doc) => {
        setViewingDoc(doc);
    };

    return (
        <div id="doc_tab" className="tab-pane fade">
            <div className="card-body">
                {documents.length === 0 ? (
                    <p className="text-muted">Nenhum documento enviado ainda.</p>
                ) : (
                    <div className="table-responsive">
                        <table className="table table-bordered">
                            <thead>
                            <tr>
                                <th>Tipo</th>
                                <th>Número</th>
                                <th>Estado</th>
                                <th>Tipo Pessoa</th>
                                <th>Ações</th>
                            </tr>
                            </thead>
                            <tbody>
                            {loadingPage ? (
                                Array.from({length: 3}).map((_, index) => (
                                    <tr key={index}>
                                        <td><Skeleton height={20}/></td>
                                        <td><Skeleton height={20}/></td>
                                        <td><Skeleton height={20}/></td>
                                        <td><Skeleton height={20}/></td>
                                        <td>
                                            <Skeleton height={30} width={90} className="me-2 d-inline-block"/>
                                            <Skeleton height={30} width={70} className="me-2 d-inline-block"/>
                                            <Skeleton height={30} width={70} className="d-inline-block"/>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                documents.map(doc => (
                                    <tr key={doc.id}>
                                        <td>{doc.doc_type?.name || '-'}</td>
                                        <td>{doc.doc_number || '-'}</td>
                                        <td>{doc.state || '-'}</td>
                                        <td>{doc.type_of_person === 1 ? "Física" : doc.type_of_person === 2 ? "Jurídica" : "-"}</td>
                                        <td>
                                            {doc?.path && (
                                                <button  type="button" className="btn btn-sm btn-primary me-2"
                                                        onClick={() => handleViewDocument(doc)} data-bs-toggle="modal"
                                                        data-bs-target="#viewDocumentModal">Visualizar</button>
                                            )}
                                            <button type="button" className="btn btn-sm btn-info me-2"
                                                    onClick={() => handleEditDocument(doc)}>Editar
                                            </button>
                                            <button type="button" className="btn btn-sm btn-danger"
                                                    onClick={() => handleDeleteDocument(doc.id)}>Excluir
                                            </button>
                                        </td>
                                    </tr>
                                ))
                            )}
                            </tbody>

                        </table>
                    </div>
                )}
            </div>

            <DocEditModal
                show={showEditModal}
                onHide={() => setShowEditModal(false)}
                doc={editingDoc}
                ufs={ufs}
                onSaveSuccess={() => {
                    setShowEditModal(false);
                    reflesh(true);
                }}
            />

            <div className="modal fade" id="viewDocumentModal" tabIndex="-1" aria-labelledby="viewDocumentModalLabel"
                 aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered modal-xl">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="viewDocumentModalLabel">Visualizar Documento</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"
                                    onClick={() => setViewingDoc(null)}></button>
                        </div>
                        <div className="modal-body">
                            {viewingDoc && (
                                viewingDoc.path.endsWith(".pdf") ? (
                                    <embed src={viewingDoc.path} type="application/pdf" width="100%" height="600px"/>
                                ) : (
                                    <img src={viewingDoc.path} alt="Documento" className="img-fluid"/>
                                )
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DocumentsTab;
